<template>
  <nav>
    <v-row
      class="fill-height"
      align="center"
    >
      <v-col
        cols="12"
        align="center"
      >
        <v-card
          elevation="0"
          color="background"
          max-width="400"
        > 
          <v-card-title class="text-h5 font-weight-bold text-center justify-center mb-4 no-break">
            {{ $t('qrCodeHubTitle') }}
          </v-card-title>
          <v-card-subtitle class="text-body-1 darktext--text no-break">
            {{ $t('qrCodeHubText') }}
          </v-card-subtitle>
        </v-card>
        <v-card
          elevation="0"
          rounded="xxl"
          color="background"
          max-width="400"
          class="overflow-y-auto"
        >
          <v-card-text class="white pa-8 overflow-y-auto" style="width: 400px;">
            <v-btn data-testid="download-qr-code-button" @click="downloadQRCode" color="accent" class="rounded-xxl text-none px-4 mt-4 mb-4" >
              {{ $t('download') }} <v-icon> mdi-download </v-icon>
            </v-btn>
            <br />
            <vue-qrcode :value="url" :options="{ width: 300, color: { dark: '#000000', light: '#ffffff' }, }" tag="img" id="qr-code"></vue-qrcode>
          </v-card-text>
        </v-card>
        <v-row>
          <v-col align="center">
            <FormFooter
              :cancel-button-link="cancelLink"
              :hide-submit="true"
              cancel-button-text="back"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>             
  </nav>
</template>
<script>

import VueQrcode from '@chenfengyuan/vue-qrcode';
import FormFooter  from '../../components/FormFooter'
import { getHub } from '../../api/hubApi'

export default {
    components: {
        VueQrcode,
        FormFooter
    },
    data () {
        return {
            url: window.location.origin + '/hub/' + this.$route.params.id,
            cancelLink: '/hub/'+this.$route.params.id
        }
    },
    beforeRouteEnter(to, from, next) {
        if(from.path != null && from.path != '/redirect' && from.path != '/'){
            next(vm => {
                vm.cancelLink = from.path
            });
        }else { 
            next();
        }
    },
    
    methods: {
        async downloadQRCode(){
            var filename = "qrcode-hub.png"
            const response = await getHub(this.$route.params.id)
            if(response.status == 200) {
                filename = response.data.data.attributes.title + '.png'
            }   
            const myCanvas = document.getElementById('qr-code')
            const anchor = document.createElement("a");

            anchor.href = myCanvas.src
            anchor.target = "_blank";
            anchor.download = filename
            anchor.click();
        }
    }
    
}

</script>